export default {
  title: "Validate your ID",
  verifyTitle: "Scan your ID",
  verify: "Verify",
  noIne: "I don't have ID",
  getIneTitle: "Get ID",
  getIneCardTitle: "Get your official INE identification",
  getIneDescription:
    "On this page you will find direct access to the official site of the National Electoral Institute (INE), where you can consult the requirements, schedule an appointment and carry out the necessary procedures to obtain your voter ID. You will be securely redirected to the official portal to complete your process quickly and reliably.",
  getIneButton: "Get",
  disconnect: "Disconnect",
  disconnectModal: {
    title: "Leave registration",
    message: "You are about to leave the registration with the email",
    warning: "If you leave, you will need to restart the registration",
    alternative: "If you prefer a different email, start a new registration",
    confirm: "Yes, leave",
    cancel: "Continue registration",
  },
  loading: "Loading...",
  retry: "Retry",
  retryTitle: "Try again",
  retryDeclinedCardTitle: "We couldn't verify your identity",
  retryDeclinedCardMessage:
    "To make it work this time: retry in a well-lit place, make sure no one else appears in your selfie, and check that your ID photo looks sharp and free of glare.",
  retryExpiredCardTitle: "Your session has expired",
  retryExpiredCardMessage:
    "Your verification expired before it was completed. Try again to continue your registration.",
  retryAbandonedCardTitle: "Incomplete verification",
  retryAbandonedCardMessage: "You didn't finish the verification process. Try again to complete your registration.",
}
